import { useContext } from 'react';
import { RefreshContext } from '../context/RefreshContext';

export const useRefresh = () => {
  return useContext(RefreshContext);
};